import { forwardRef } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

// Keep the original controls visible, while making the master's read-only mode explicit.
const WriteButton = forwardRef(({ plain = false, disabled, title, ...props }, ref) => {
  const { readOnly } = useAuth();
  const Component = plain ? "button" : Button;
  return <Component {...props} ref={ref} disabled={readOnly || disabled}
    title={readOnly ? "Master hanya dapat melihat data tenant" : title} data-write-action="true" />;
});
WriteButton.displayName = "WriteButton";
export default WriteButton;
